import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Builder from './Builder';
import Instagram from './Instagram';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/builder" element={<Builder />} />
        <Route path="/instagram" element={<Instagram />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
